import useParseViewPropsToWeb from "src/hooks/useParseViewPropsToWeb";
import { TouchableWithoutFeedbackProps } from "./types";

const TouchableWithoutFeedback = ({
	children,
	onPress,
	testID,
	style,
	containerStyle,
}: TouchableWithoutFeedbackProps) => {
	const { style: resolvedStyle } = useParseViewPropsToWeb({ style });
	const { style: resolvedContainerStyle } = useParseViewPropsToWeb({ style: containerStyle });

	return (
		<div data-testid={testID} onClick={onPress} style={resolvedContainerStyle}>
			<div style={resolvedStyle}>{children}</div>
		</div>
	);
};
export default TouchableWithoutFeedback;
